import { ICommonIconProps } from "../types";

/**
 * -----------------------------------------------------------------------------
 * Renders a cart with a clock icon to denote a return is in progress.
 */
export function CartReturnIcon({ className }: ICommonIconProps) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24">
      <circle
        cx="6"
        cy="20"
        r="2"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <circle
        cx="17"
        cy="20"
        r="2"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M22 5H21C19.8954 5 19 5.89543 19 7V16C19 17.1046 18.1046 18 17 18H3"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <circle
        cx="9.5"
        cy="10.5"
        r="4.5"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M9.19901 8.967V11H10.886"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

